import {
	MentorProductBase,
	flagValidationErrorsInMentorProductBase
} from "types-and-validators/MentorProductBase";

export type SingleSessionPriceBase = MentorProductBase;

export const flagValidationErrorsInSingleSessionPriceBase = flagValidationErrorsInMentorProductBase;
